import React from 'react';
import { FlexRow } from '@guryou/html-components';

const MainContainer = ({ children, alignItems = 'start' }) => {
  return (
    <FlexRow height="fit-content" xs={12} maxWidth={1120} margin="0 auto" alignItems={alignItems} justifyContent="space-around" marginTop={2}>
      {children}
    </FlexRow>
  );
};

export default MainContainer;
